
import { queryClient } from '@api/queryClient';
import AppRoutes from '@app/config/AppRoutes';
import AuthProvider from '@app/context/AuthProvider';
import { LocalizationProvider } from '@app/context/LocalizationProvider';
import { FormStepProvider } from '@pages/AdmissionsStages/formContext';
import { QueryClientProvider } from '@tanstack/react-query';
import { ConfigProvider } from 'antd';
import { Suspense } from 'react';
import { BrowserRouter } from 'react-router-dom';
import './App.css';
import IconPage from './skeleton/IconPage';

function App() {
  // const { getDesignToken } = theme;
  // const { isOnline } = useNetworkStatus()
  const themeConfig = {
    token: {

    },
  };

  const basename = import.meta.env.VITE_BASE_PATH || '/';
  return (
    <>
      <Suspense fallback={<IconPage />}>
        <QueryClientProvider client={queryClient}>
          <LocalizationProvider>
            <BrowserRouter basename={basename}>
              <ConfigProvider theme={themeConfig}>
                <AuthProvider>
                  <FormStepProvider>
                    <AppRoutes />
                  </FormStepProvider>
                </AuthProvider>
              </ConfigProvider>

            </BrowserRouter>
          </LocalizationProvider>
        </QueryClientProvider>
      </Suspense>
    </>
  )
}

export default App
